import { render, staticRenderFns } from "./PaperRedactions.vue?vue&type=template&id=07262b7f&scoped=true&"
import script from "./PaperRedactions.vue?vue&type=script&lang=js&"
export * from "./PaperRedactions.vue?vue&type=script&lang=js&"
import style0 from "./PaperRedactions.vue?vue&type=style&index=0&id=07262b7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07262b7f",
  null
  
)

export default component.exports